"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommsUtils = void 0;
var Hogan = require("hogan.js");
var CommsUtils = /** @class */ (function () {
    function CommsUtils() {
    }
    CommsUtils.buildContent = function (emailData) {
        var partials = {
            header: Hogan.compile(emailData.headerHtml),
            body: Hogan.compile(emailData.bodyHtml),
            footer: Hogan.compile(emailData.footerHtml),
        };
        return Hogan.compile(emailData.commsStructure).render(emailData, partials);
    };
    CommsUtils.buildSubject = function (subjectHtml, emailData) {
        return Hogan.compile(subjectHtml).render(emailData);
    };
    return CommsUtils;
}());
exports.CommsUtils = CommsUtils;
